export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-view-block/_content-section-view-block.twig";